import { useMemo } from 'react';
import { VacationPaidRestHistoryPanel } from '@/features/Vacations/components/VacationPaidRestHistoryModal/VacationPaidRestHistoryPanel';
import { buildPaidRestDemoRow } from './paidRestDemo.definitions';

const noop = () => {};

export function TourDemoPaidRestHistory() {
    const row = useMemo(() => buildPaidRestDemoRow(new Date()), []);

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
            <div
                data-tour="paidrest-history-demo"
                className="flex max-h-[90vh] w-full max-w-2xl flex-col overflow-hidden rounded-2xl bg-white shadow-xl"
            >
                <VacationPaidRestHistoryPanel row={row} titleId="tour-demo-paidrest-title" onClose={noop} />
            </div>
        </div>
    );
}

export default TourDemoPaidRestHistory;
